import React from 'react';

import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import Table from '../../../../Table';
import AddOrEditPageTabs from '../../../AddOrEditPageTabs';

import LoanService from '../../../../../services/LoanService';

const tabs = [
  {
    label: 'Insurances',
  },
  {
    label: 'Claims',
  },
];

const cols = [
  {
    title: 'Date Submitted',
    keys: ['date_submitted'],
    type: 'date',
  },
  {
    title: 'Insurance',
    keys: ['_insurance.policy_number'],
    link: (row) =>
      `/loans/${row.loan_id}/insurances/${row.insurance_id}?tab=Insurance`,
  },
  {
    title: 'Amount',
    keys: ['claim_amount'],
    type: 'currency',
  },
  {
    title: 'Cause',
    keys: ['cause'],
    format: (value) => {
      const map = {
        WIND_HAIL: 'Wind or Hail',
        FIRE: 'Fire',
        FLOOD: 'Flood',
      };

      return map[value] || value;
    },
  },
  {
    title: 'Status',
    keys: ['status'],
    link: (row) => `/loans/${row.loan_id}/claims/${row.id}?tab=Claim`,
  },
];

export default function Claims({ loanId }) {
  const navigate = useNavigate();

  const { data: claims, isFetching } = useQuery({
    queryKey: ['claims', loanId],
    queryFn: () => LoanService.getLoanClaims(loanId),
    enabled: !!loanId,
  });

  return (
    <div>
      <div className="mb-4 flex justify-between md:items-center flex-col md:flex-row gap-2 h-[37px]">
        <AddOrEditPageTabs tabs={tabs} />
      </div>
      <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
        <div className="flex flex-col sm:flex-row justify-between sm:items-center mb-6 gap-4">
          <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold">
            Claims
          </h2>

          <button
            onClick={() => navigate(`/loans/${loanId}/claims/new?tab=Claim`)}
            className="btn bg-indigo-500 hover:bg-indigo-600 text-white"
            type="button"
          >
            <svg
              className="w-4 h-4 fill-current opacity-50 shrink-0"
              viewBox="0 0 16 16"
            >
              <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
            </svg>
            <span className="hidden xs:block ml-2">Create Claim</span>
          </button>
        </div>
        <Table
          cols={cols}
          rows={claims}
          title="Claims"
          isFetching={isFetching}
          minHeight={565}
        />
        {/*    {isLender && (
          <Pagination
            pageTotal={pageTotal}
            switchToPage={switchToPage}
            currentPage={currentPage}
          />
        )} */}
      </div>
    </div>
  );
}
